import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useClassiUtenti from '../../hooks/useClassiUtenti';
import CardLoadingPage from '../../components/CardLoadingPage/CardLoadingPage';
import useMediaQuery from '../../hooks/useMediaQuery';
import { TIPO_CORSO } from '../../model/tipoCorso';
import UtilityService from '../../services/UtillityServices/UtilityService';

const AreaPersonaleCorsiPage = () => {
  const { getClassiUtenteByToken, loadingStateClassiUtenti } = useClassiUtenti();
  const [classiUtente, setClassiUtente] = useState([]);
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 767px)');

  useEffect(() => {
    fetchClassiUtenteByToken();
  }, []);

  const fetchClassiUtenteByToken = async () => {
    const fetchedClassiUtente = await getClassiUtenteByToken();
    setClassiUtente(fetchedClassiUtente || []);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const handleAccediClasse = (classe) => {
    console.log(classe, 'CLASSE TRAMITE AREA PERSONALE CORSI');
    if(classe.cond1 == 0 || classe.cond2 == 0 || classe.cond3 == 0){
      navigate(`/corso/${classe.id_classe}`, { state: { classe } });
    }
    else{
      if(classe.corso.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA) {
        navigate(`/area-personale/corso`, {state: {classe: classe, stato_pagamento: classe.stato_pagamento}});
      } else {
        navigate(`/area-personale/classe`, {state: {classe: classe, stato_pagamento: classe.stato_pagamento}});
      }
    }
  };

  const handleAcquisto = (classe) => {
    //navigate(`/checkout`, { state: { courseData: classe } });
    navigate(`/corso/${classe.id_classe}`, { state: { classe } });//NEW
  };

  const shouldRenderCard = (classe) => {
    return true;
  };

  const renderButton = (classe) => {
    const isTelematicaAsincrona = classe.corso.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA;
    const isPagato = (classe.stato_pagamento === 'Pagato' || classe.stato_pagamento === 'Parzialmente_pagato');//NEW
    //const isPagato = classe.stato_pagamento === 'Pagato';
    const isBonificoCorsista = classe.is_bonifico_corsista == '1';//NEW

    if (!isPagato && isBonificoCorsista) {//NEW
      return (
        <button 
          className="btn btn-primary w-100" 
          disabled
        >
          <i className="bi bi-arrow-repeat me-2"></i>Verifica bonifico in corso...
        </button>
      );
    }
    
    if (!isPagato) {
      return (
        <button 
          className="btn btn-primary w-100" 
          onClick={() => handleAcquisto(classe)}
        >
          <i className="bi bi-cart me-2"></i>Acquista ora
        </button>
      );
    }

    if (isTelematicaAsincrona) {
      return (
        <button 
          className="btn btn-primary w-100" 
          onClick={() => handleAccediClasse(classe)}
        >
          <i className="bi bi-play-circle me-2"></i>Accedi al corso
        </button>
      );
    }

    return (
      <button 
        className="btn btn-primary w-100" 
        onClick={() => handleAccediClasse(classe)}
      >
        <i className="bi bi-door-open me-2"></i>Accedi alla Classe
      </button>
    );
  };

  const renderPrice = (classe) => {
    const prezzo = parseFloat(classe.corso.prezzo) || 0;
    const sconto = parseFloat(classe.sconto) || 0;

    if (sconto > 0) {
      return (
        <p className="card-text">
          <span className="text-decoration-line-through text-muted me-2">
            {prezzo.toFixed(2)}€
          </span>
          <span className="text-success">
            <b>{(prezzo - sconto).toFixed(2)}€</b>
          </span>
        </p>
      );
    }

    return <p className="card-text"><b>{prezzo.toFixed(2)}€</b></p>;
  };

  if (loadingStateClassiUtenti.isLoadingClassiUtenteByToken) {
    return <CardLoadingPage />;
  }

  return (
    <div className={`card custom-card w-100 shadow`}>
      <div className={`${isMobile ? 'p-3' : 'p-5'}`}>
        <div className='container' style={{minHeight: '700px'}}>
          <div className='d-flex justify-content-between custom-card-header mb-4'>
            <div className='d-flex gap-3'>
              <div className={`custom-icon-container`}>
                <i className={`bi custom-icon bi-mortarboard fs-2`}></i>
              </div>
              <div className='align-self-center'>
                <span className='fs-4 d-block'><i><b>I Miei Corsi</b></i></span>
                <p className={`lead mb-0 ${isMobile ? 'd-none d-md-block' : ''}`}>Gestisci i tuoi corsi e accedi ai materiali didattici</p>
              </div>
            </div>
          </div>
          {isMobile && (
            <p className="lead mb-4">Gestisci i tuoi corsi e accedi ai materiali didattici</p>
          )}
          <div className='container'>
            <div className='row mt-4'>
              {classiUtente?.length === 0 ? (
                <div className='my-5'>
                  <p>Non sei iscritto a nessun corso al momento.</p>
                </div>
              ) : (
                classiUtente
                  ?.filter(shouldRenderCard)
                  .map((classe) => (
                    <div key={classe.id_classe_utente} className="col-md-6 col-xl-3 mb-4">
                      <div className="card h-100 shadow-sm">
                        <img src={classe.corso.immagine_corso} className="card-img-top" alt={classe.corso.denominazione} style={{height: '200px', objectFit: 'cover'}} />
                        <div className="card-body d-flex flex-column justify-content-between">
                          <h5 className="card-title">{classe.corso.denominazione}</h5>
                              <small className="text-muted d-block">
                                Corso in modalitá {UtilityService.getModalitaErogazione(classe?.corso?.modalita_erogazione)}
                              </small>
                          {classe.corso.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA ? (
                            <p className="card-text">
                              <small className="text-muted d-block">
                                Durata: {classe.corso.durata} ore
                              </small>
                            </p>
                          ) : (
                            <p className="card-text">
                              <small className="text-muted">
                                Dal {formatDate(classe.data_inizio)} al {formatDate(classe.data_fine)}
                              </small>
                            </p>
                          )}
                          {
                            classe.stato_pagamento !== 'Pagato' && classe.stato_pagamento !== 'Parzialmente_pagato' && (//NEW
                              renderPrice(classe)
                            )
                          }
                          {renderButton(classe)}
                        </div>
                      </div>
                    </div>
                  ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AreaPersonaleCorsiPage;
